module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Published in 2009 by")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copyright0"
  }, [_vm._v("Academy Chicago Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("363 West Erie Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("Chicago, Illinois 60654")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("© 2009 David Schmahmann")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Printed in the U.S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("No part of this book may be reproduced in any form without the express written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data on file with the publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d3850ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Copyright.vue
// module id = 66
// module chunks = 0